<template>
  <div id="app">
    
    <router-view/>

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{
    margin: 0px;
    padding:0px;
  }
   #app,body,html{
    width:100%;
    height:100%;
    position: relative;
    font-size: 14px;
    color:#3D404D;
    font-family:Microsoft YaHei;
   }
/*  @media screen and (max-width: 1280px){
    #app,body,html{
      width:1280px;
      height:800px;
    }
  }*/
  input::-webkit-input-placeholder,input:-webkit-autofill,
  input:-webkit-autofill:hover,
  /* input:-webkit-autofill:focus{ 
           color: #aab2bd;
           font-size: 15px;
           text-align: left;
            box-shadow:0 0 0 60px #ffffff inset;
            -webkit-text-fill-color: #878787;
  } */
  input{
    outline-style: none;
  }
  div:after,ul:after,li:after{
    display:block;
    clear: both;
    content:'';
  }
  .tangram-suggestion-main{
    z-index: 9999
  }
  .el-dialog__header{
    background:rgba(240,243,250,1);
    height:61px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .el-dialog__title{
    color: #333333;
    font-size: 16px;
    font-weight:bold;
  }
  .el-dialog{
    border-radius:10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue